var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCargoPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 33,
    viewBox: "0 0 21 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_798_17245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.08746 3.0375C7.08746 2.2319 7.40748 1.4593 7.97712 0.889663C8.54676 0.320021 9.31936 0 10.125 0C10.9306 0 11.7032 0.320021 12.2728 0.889663C12.8424 1.4593 13.1625 2.2319 13.1625 3.0375C13.1625 3.84309 12.8424 4.61569 12.2728 5.18534C11.7032 5.75498 10.9306 6.075 10.125 6.075C9.31936 6.075 8.54676 5.75498 7.97712 5.18534C7.40748 4.61569 7.08746 3.84309 7.08746 3.0375ZM9.61871 22.275V30.375C9.61871 31.4951 8.71379 32.4 7.59371 32.4C6.47363 32.4 5.56871 31.4951 5.56871 30.375V16.257L3.75886 19.2691C3.183 20.2247 1.93636 20.5348 0.980817 19.9589C0.0252698 19.383 -0.284808 18.1364 0.291051 17.1809L3.98035 11.0426C5.08144 9.21375 7.05582 8.09367 9.18839 8.09367H11.0678C13.2004 8.09367 15.1748 9.21375 16.2759 11.0426L19.9652 17.1809C20.541 18.1364 20.231 19.383 19.2754 19.9589C18.3199 20.5348 17.0732 20.2247 16.4974 19.2691L14.6812 16.257V30.375C14.6812 31.4951 13.7763 32.4 12.6562 32.4C11.5361 32.4 10.6312 31.4951 10.6312 30.375V22.275H9.61871Z",
    fill: "#404041"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_798_17245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.25,
    height: 32.4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCargoPerson);
export default __webpack_public_path__ + "static/media/cargo-person.0acb6e3ea0d9ac123253e26c7bfafcbd.svg";
export { ForwardRef as ReactComponent };